import { render, staticRenderFns } from "./inairthreshold.vue?vue&type=template&id=7549dc42&scoped=true&"
import script from "./inairthreshold.vue?vue&type=script&lang=ts&"
export * from "./inairthreshold.vue?vue&type=script&lang=ts&"
import style0 from "./inairthreshold.vue?vue&type=style&index=0&id=7549dc42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7549dc42",
  null
  
)

export default component.exports